import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Button } from 'react-bootstrap';
import { CardElement } from '@stripe/react-stripe-js';

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: '16px',
      color: '#495057',
      '::placeholder': { color: '#6c757d' }, // TODO: what is this?
    },
    invalid: {
      color: '#dc3545',
    },
  },
};

export default function CreditCardInfoForm({ handleCreditCardSubmit, goBack }) {
  const [cardComplete, setCardComplete] = useState(false);
  const [cardError, setCardError] = useState(null);

  const handleCardChange = (event) => {
    setCardComplete(event.complete);
    setCardError(event.error ? event.error.message : null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (cardComplete && !cardError) {
      handleCreditCardSubmit();
    }
  }

  return (
    <Form id="PaymentForm" className="mb-3" onSubmit={handleSubmit}>

      <section className="mt-3">
        <Form.Group className="mt-2">
          <Form.Label>Card Details</Form.Label>
          <div
            className={`form-control ${cardError ? 'is-invalid' : ''}`}
            style={{ padding: '10px 12px' }}
          >
            <CardElement
              options={CARD_ELEMENT_OPTIONS}
              onChange={handleCardChange}
            />
          </div>
          {cardError && (
            <div className="invalid-feedback" style={{ display: 'block' }}>
              {cardError}
            </div>
          )}
        </Form.Group>

      </section>

      <div className="mt-3 d-flex justify-content-around">
        <Button
          onClick={goBack}
          variant="dark"
        >
          Go Back
        </Button>
        <Button
          type="submit"
          disabled={!cardComplete || !!cardError}
          variant="primary"
        >
          Submit
        </Button>
      </div>
    </Form>
  );
}

CreditCardInfoForm.propTypes = {
  handleCreditCardSubmit: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
};
